
import React, { useState } from 'react';
import './InchidereContCard.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faTriangleExclamation,
  faLock,
  faCreditCard
} from '@fortawesome/free-solid-svg-icons';

const CONFIRM_WORD = 'STERGE';

const InchidereContCard = ({ handleDeleteAccount, deleting = false, error = '' }) => {
  const [confirmText, setConfirmText] = useState('');
  const confirmed = confirmText.trim().toUpperCase() === CONFIRM_WORD;

  return (
    <div className="inchidere-cont-card">
      <h4 className="inchidere-cont-title">
        Inchidere cont
      </h4>

      <div className="inchidere-cont-warning">
        <div className="inchidere-cont-icon-wrapper">
          <FontAwesomeIcon icon={faTriangleExclamation} />
        </div>

        <h5 className="inchidere-cont-warning-title">
          Atentie! Aceasta actiune este ireversibila
        </h5>

        <p className="inchidere-cont-description">
          Inchiderea definitiva a contului tau va avea
          urmatoarele consecinte:
        </p>

        <div className="inchidere-cont-consequences">
          <div className="inchidere-cont-consequence">
            <div className="inchidere-cont-consequence-icon">
              <FontAwesomeIcon icon={faTrash} />
            </div>

            <div className="inchidere-cont-consequence-text">
              <strong>Stergerea permanenta</strong>
              <span>
                Datele asociate contului vor fi sterse definitiv.
              </span>
            </div>
          </div>

          <div className="inchidere-cont-consequence">
            <div className="inchidere-cont-consequence-icon">
              <FontAwesomeIcon icon={faLock} />
            </div>

            <div className="inchidere-cont-consequence-text">
              <strong>Pierderea accesului</strong>
              <span>
                Nu vei mai putea accesa contul si progresul lectiilor.
              </span>
            </div>
          </div>

          <div className="inchidere-cont-consequence">
            <div className="inchidere-cont-consequence-icon">
              <FontAwesomeIcon icon={faCreditCard} />
            </div>

            <div className="inchidere-cont-consequence-text">
              <strong>Abonamentul activ</strong>
              <span>
                Daca ai un abonament, verifica anularea acestuia
                inainte de stergerea contului.
              </span>
            </div>
          </div>
        </div>

        <div className="inchidere-cont-actions">
          <label className="inchidere-cont-confirm-label" htmlFor="inchidere-cont-confirm">
            Pentru confirmare, scrie <strong>{CONFIRM_WORD}</strong>
          </label>
          <input
            id="inchidere-cont-confirm"
            type="text"
            className="inchidere-cont-confirm-input"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            autoComplete="off"
            disabled={deleting}
          />
          {error && (
            <p className="inchidere-cont-error" role="alert">{error}</p>
          )}
          <button
            type="button"
            className="inchidere-cont-delete-button"
            onClick={handleDeleteAccount}
            disabled={typeof handleDeleteAccount !== 'function' || !confirmed || deleting}
          >
            <FontAwesomeIcon icon={faTrash} />
            {deleting ? 'Se sterge...' : 'Inchide contul permanent'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InchidereContCard;
